import { MapReportModel } from '@/models/MapReport/MapReportModel'

export class MapReportSearchResults {
  constructor(data = {}, pageSize) {
    const { items, count, pageNo } = data
    this.items = items.map(MapReportModel.assign)
    this.count = count
    this.pageNo = pageNo
    this.pageSize = pageSize
  }
  static assign(data, pageSize) {
    return new MapReportSearchResults(data, pageSize)
  }
}
